import { Capacitor } from '@capacitor/core';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { COMPATIBLE_APP_VERSION } from 'App/version';

const { VITE_APP_ENV, VITE_APP_VERSION, VITE_API_BFF } = import.meta.env;

const isProd = VITE_APP_ENV === 'production';
const isStaging = VITE_APP_ENV === 'staging';

const commonDatadogConfig = {
  site: 'datadoghq.com',
  env: VITE_APP_ENV,
  useCrossSiteSessionCookie: true,
};

const getMobileVersion = () => {
  if (Capacitor.getPlatform() !== 'web')
    return `${Capacitor.getPlatform()}-${COMPATIBLE_APP_VERSION}`;

  return `web-mobile-${VITE_APP_VERSION}`;
};

const datadogConfig = {
  mobile: {
    clientToken: 'pub9e4b9aef163b9b435e53357e68a08ad0',
    applicationId: '4ae00425-a705-4e78-b573-aa5d20d219a1',
    service: 'frontend-new-admin-mobile',
    version: getMobileVersion(),
    ...commonDatadogConfig,
  },
  web: {
    clientToken: 'pub1c244f94fab8283bad2801bbcdc40212',
    applicationId: '8e9868f9-2d3e-4509-81c5-a1e5c6471abd',
    service: 'frontend-new-admin-web',
    version: `${VITE_APP_ENV}-${VITE_APP_VERSION}`,
    ...commonDatadogConfig,
  },
};
function initDatadogConfig(isMobile: boolean) {
  const defaultConfig = datadogConfig[isMobile ? 'mobile' : 'web'];
  datadogRum.init({
    ...defaultConfig,
    allowedTracingUrls: [
      'https://cirrus.tiendanube.com',
      (url) => url.startsWith(VITE_API_BFF),
    ],
    sessionSampleRate: isProd ? 20 : 0,
    sessionReplaySampleRate: isProd ? 20 : 0,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
  });

  datadogLogs.init({
    ...defaultConfig,
    forwardErrorsToLogs: true,
    sessionSampleRate: isProd ? 100 : 0,
  });
}

if (isProd || isStaging) initDatadogConfig(Capacitor.isNativePlatform());
